/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Flagged Ids Reducer
 */

import type { FlaggedIds } from '@zcode/state-type'
import type { Values } from '@zcode/utility-types'
import { combineReducers } from 'redux'
import { type ExtractActions, handleActions } from 'redux-actions'
import type { receiveLocalizerValues } from '../../../actions'
import { RECEIVE_LOCALIZER_VALUES } from '../../../actions/constants'
import type * as actions from '../actions/index'
import { FLAG_BUILDING, FLAG_LISTING } from '../constants/index'

type Actions = ExtractActions<typeof receiveLocalizerValues | Values<typeof actions>>

const flaggedIdsReducer = combineReducers({
  flaggedBuildings: handleActions<FlaggedIds['flaggedBuildings'], Actions>(
    {
      [FLAG_BUILDING]: (state, { payload: { buildingId } }) => {
        return { ...state, [buildingId]: true }
      },
      [RECEIVE_LOCALIZER_VALUES]: (state, { payload: { flaggedIds } }) => {
        if (flaggedIds.flaggedBuildings) {
          return flaggedIds.flaggedBuildings
        }
        return state
      },
    },
    {}
  ),
  flaggedListings: handleActions<FlaggedIds['flaggedListings'], Actions>(
    {
      [FLAG_LISTING]: (state, { payload: { listingId } }) => {
        return { ...state, [listingId]: true }
      },
      [RECEIVE_LOCALIZER_VALUES]: (state, { payload: { flaggedIds } }) => {
        if (flaggedIds.flaggedListings) {
          return flaggedIds.flaggedListings
        }
        return state
      },
    },
    {}
  ),
})

export default flaggedIdsReducer
